// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qbHy","fullView":"styles_fullView__188-A"};